import { GameModal } from './GameModal';
import { COLORS, LABELS } from '@/game/configs';
import { XCircle } from 'lucide-react';
interface GameOverModalProps {
  isOpen: boolean;
  time: number;
  onTryAgain: () => void;
  onReturnToLobby: () => void;
}
export function GameOverModal({
  isOpen,
  time,
  onTryAgain,
  onReturnToLobby,
}: GameOverModalProps) {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return (
    <GameModal isOpen={isOpen}>
      <div className="flex flex-col items-center text-center gap-4">
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center"
          style={{
            backgroundColor: '#FEE2E2',
            boxShadow: '4px 4px 12px rgba(220, 38, 38, 0.2)',
          }}
        >
          <XCircle size={32} style={{ color: '#DC2626' }} />
        </div>
        <div className="flex flex-col gap-1">
          <h2
            className="text-2xl sm:text-3xl font-extrabold"
            style={{
              fontFamily: 'Nunito, system-ui, sans-serif',
              color: COLORS.dark,
            }}
          >
            {LABELS.gameOver}
          </h2>
          <p
            className="text-base"
            style={{
              fontFamily: 'Nunito, system-ui, sans-serif',
              color: '#DC2626',
            }}
          >
            {LABELS.threeMistakes}
          </p>
          <p
            className="text-sm"
            style={{
              fontFamily: 'Nunito, system-ui, sans-serif',
              color: COLORS.brown,
            }}
          >
            Time: {formatTime(time)}
          </p>
        </div>
        <div className="flex flex-col gap-3 w-full mt-4">
          <button
            onClick={onTryAgain}
            className="w-full py-4 rounded-2xl font-bold text-lg transition-all duration-150 active:scale-98"
            style={{
              backgroundColor: COLORS.yellow,
              boxShadow: '4px 4px 8px rgba(139, 115, 85, 0.3)',
              fontFamily: 'Nunito, system-ui, sans-serif',
              color: COLORS.dark,
            }}
          >
            Try Again
          </button>
          <button
            onClick={onReturnToLobby}
            className="w-full py-3 rounded-2xl font-semibold text-base transition-all duration-150 active:scale-98"
            style={{
              backgroundColor: COLORS.ivory,
              boxShadow: '4px 4px 8px rgba(139, 115, 85, 0.2)',
              fontFamily: 'Nunito, system-ui, sans-serif',
              color: COLORS.brown,
            }}
          >
            {LABELS.returnToLobby}
          </button>
        </div>
      </div>
    </GameModal>
  );
}